import SelectAutocomplete from '../Common/SelectAutocomplete';

const SelectAutocompleteWrapper = objProps => {
  return <SelectAutocomplete {...objProps.field} {...objProps} />;
};

export default SelectAutocompleteWrapper;
